import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "spritesheets/cards/backs/8_card_back_cat_head/8_card_back_cat_head"
 * Contains 1 texture(s)
 */
export class CardsBacks8CardBackCatHeadAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'spritesheets/cards/backs/8_card_back_cat_head/8_card_back_cat_head';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '8_cat_head.png'
    ] as const;
}
